import { Injectable } from '@angular/core';
import { SourceAccount, TransferOrder, TransferOrderToXLS } from './../interfaces/all';
@Injectable({
  providedIn: 'root'
})

export class TechcombankService implements TransferOrderToXLS {

  public extractInternalXLS(source: SourceAccount, data: Array<TransferOrder>): Array<object> {

    let xls = [];

    xls.push({
      'TÀI KHOẢN ĐÍCH': '',
      'SỐ TIỀN CHUYỂN': '',
      'DIỄN GIẢI': '',
    });

    for (let i = 0; i < data.length; i++) {
      xls.push({
        'TÀI KHOẢN ĐÍCH': data[i].target.account,
        'SỐ TIỀN CHUYỂN': Math.round(data[i].amount),
        'DIỄN GIẢI': data[i].notes
      });
    }

    return xls;
  }

  public extractExternalXLS(Source: SourceAccount, data: Array<TransferOrder>): Array<object> {

    let xls = [];

    for (let i = 0; i < data.length; i++) {

      let str = "" + (i + 1);
      let pad = "0000";
      let ans = pad.substring(0, pad.length - str.length) + str;

      if (data[i].target.region.toLowerCase() == 'ca nuoc') {

        xls.push({
          'Txn Reference Số tham chiếu': 'REF' + ans,
          'Amount (VND) Số tiền chuyển': Math.round(data[i].amount),
          'Beneficiary Name Tên người nhận': data[i].target.owner,
          'Account Number Tài khoản nhận': data[i].target.account,
          'Remarks Nội dung': data[i].notes,
          'Ben Bank Ngân hàng chuyển': data[i].target.branch,
          'Province Địa bàn': '',
          'Branch Chi nhánh': '',
          'Validation Kiểm tra': 'OK',
        });
      }
      else {

        xls.push({
          'Txn Reference Số tham chiếu': 'REF' + ans,
          'Amount (VND) Số tiền chuyển': Math.round(data[i].amount),
          'Beneficiary Name Tên người nhận': data[i].target.owner,
          'Account Number Tài khoản nhận': data[i].target.account,
          'Remarks Nội dung': data[i].notes,
          'Ben Bank Ngân hàng chuyển': data[i].target.bank,
          'Province Địa bàn': data[i].target.region,
          'Branch Chi nhánh': data[i].target.branch,
          'Validation Kiểm tra': 'OK',

        });
      }
    }

    return xls;
  }
}
